import React from 'react';
import PropTypes from 'prop-types';

function IconButton(props) {
  const {
    radius, icon, className, ...restProps
  } = props;
  return (
    <div className={`iconButton ${className}`} style={{ borderRadius: radius }} {...restProps}>
      {icon}
    </div>
  );
}

IconButton.propTypes = {
  icon: PropTypes.element,
  radius: PropTypes.number,
  className: PropTypes.string,
};

IconButton.defaultProps = {
  radius: 40,
  className: '',
  icon: undefined,
};
export default IconButton;
